__webpack_require__.p = "/wp-content/projects/tmnt-randomizer/";